import {Vue} from 'ui.vue';
import './style.scss';
Vue.component('v-popup', {
    template: `<div class="popup-mask" >
              <div ref="wrapper" class="popup-wrapper scroll-modern"  @click.self="$emit('close')">
                <div ref="container" class="popup-container" >
                  <div class="popup-header">
                  <slot name="close-icon">
                      <span class="popup-header__close"  @click="$emit('close')"></span>
                    </slot>
                    <slot name="header">
                      default header
                    </slot>
                  </div>
                  <div class="popup-body">
                    <slot name="body">
                      default body
                    </slot>
                  </div>
                  <div class="popup-footer">
                    <slot name="footer">
                      <button class="tool__button" @click="$emit('close')">
                        Закрыть
                      </button>
                    </slot>
                  </div>
                </div>
              </div>
            </div>`,
    mounted(){
        this.onResizeContainer()
    },
    methods:{
      onResizeContainer(){
          return new ResizeObserver(()=>{
              this.$refs.wrapper.style.overflowY = this.$refs.wrapper.clientHeight - this.$refs.container.clientHeight <= -30 ? "auto":"unset"
          }).observe(this.$refs.container)
      }
    }
});
